/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import {
    Container,
    Content, Form
} from './styles';
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import CustomTextInput from 'components/CustomTextInput/CustomTextInput';
import CustomButton from 'components/CustomButton/CustomButton';
import Preloader from "components/Preloader/Preloader";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion
//#region Images
import logo from 'img/logo.svg';
//#endregion
//#region Services
import { getToken, requestLogin } from "services/auth/tokenAuth";
import { requestGetPermissionsByUserId } from "services/auth/users";
import { currentUserLocalStorage } from "services/storage/general";
//#endregion
//#region Utils
import { IS_PRODUCTION } from "config/deploymentMode";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion

const Login = () => {
    const navigate = useNavigate();
    //#region States
    const [form, setForm] = useState({
        user: "",
        password: ""
    });
    const [loadingLogin, setLoadingLogin] = useState(false);
    const [errorLogin, setErrorLogin] = useState(false);
    const [readyView, setReadyView] = useState(false);
    //#endregion
    //#region Effects
    const manageBackToExitApp = () => {
        const handler = () => {
            Array(2).fill().forEach(() => window.history.back());
        };
        window.addEventListener("popstate", handler);
        return () => window.removeEventListener("popstate", handler);
    }
    useEffect(manageBackToExitApp, []);
    useEffect(() => {
        if (getToken()) {
            navigate(ABSOLUTE_PATHS.HOME);
            return;
        }
        setReadyView(true);
    }, []);
    //#endregion
    //#region Functions
    const changeForm = (field, value) => {
        setErrorLogin(false);
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
    }
    const doRequestLogin = async form => {
        return new Promise(async (resolve, reject) => {
            try {
                setLoadingLogin(true);
                const logged = await requestLogin(form);
                resolve(logged);
            }
            catch (err) { reject(err); }
            finally { setLoadingLogin(false); }
        });
    }
    const login = async e => {
        e.preventDefault();
        const logged = await doRequestLogin(form);
        if (!logged) {
            setErrorLogin(true);
            return;
        }
        const { user, modules } = await requestGetPermissionsByUserId(form.user);
        currentUserLocalStorage.set({
            ...user,
            id: form.user,
            modules
        });
        navigate(ABSOLUTE_PATHS.HOME);
    }
    const beginInDevMode = async () => {
        const logged = await doRequestLogin({
            user: "amenacho",
            password: "qBRXOD4xNI7eqPuHmpdGpw==",
        });
        if (!logged)
            return;
        navigate(ABSOLUTE_PATHS.USERS_PER_ROLE);
    }
    //#endregion
    if (!readyView)
        return null;
    const { user, password } = form;
    return (
        <Container>
            <HelmetUTP title="Login" />
            <Content>
                <header>
                    <img src={logo} alt="Logo UTP" />
                    <h1>Reservas</h1>
                </header>
                <Form onSubmit={login}>
                    <CustomTextInput
                        placeholder="Usuario"
                        value={user}
                        onChange={value => changeForm("user", value)} />
                    <CustomTextInput
                        placeholder="Contraseña"
                        type="password"
                        value={password}
                        onChange={value => changeForm("password", value)} />
                    <footer>
                        <ErrorMessage
                            error={errorLogin}
                            text="Las credenciales son incorrectas o no existen" />
                        <CustomButton
                            disabled={!user || !password}
                            text="INGRESAR" />
                    </footer>
                </Form>
                <Preloader
                    hidden={!loadingLogin}
                    message="Autenticando..." />
            </Content>
            {!IS_PRODUCTION &&
                <CustomButton
                    text="Desarrollo"
                    onClick={beginInDevMode}
                    variant="secondary" />}
        </Container>
    );
}

export default Login;